var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_icon",style:(_vm.btnStyles),on:{"click":_vm.onClick}},[(_vm.url_image)?[_c('img',{staticClass:"img_icon",attrs:{"src":_vm.iconUrl}})]:[_c('img',{staticClass:"img_icon",attrs:{"src":require(`@/assets/images/CH2/${_vm.iconUrl}`)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }